import { Component, JSX } from "react";
import "../../../../App.css";
import { appContext } from "../../../../AppContext";
import { IUserRights } from "../../../../Providers.Api/Models.UserApi";
import { IRouterProps, withRouting } from "@iconics/components";

class Root extends Component<IRouterProps>
{
    private labels = appContext().labels;
    private appState = appContext().state;
    private local = appContext().localStorageProvider;

    constructor(props: IRouterProps)
    {
        super(props);
        this.authCheck();
    }

    public authCheck(): void
    {
        const token = appContext().authentication.getToken();
        if (!token)
        {
            this.pushHistory("/login");
        }
    }

    public componentDidMount(): void
    {
        const userDetails = this.local.getUserDetails()
        if (userDetails?.userRights) 
        {
            this.redirect(userDetails.userRights);
        }
    }

    private redirect(rights: IUserRights): void
    {
        if (rights.ADMINPORTAL)
        {
            this.pushHistory(`/security-identity-providers`);
        }
        else
        {
            this.pushHistory("/norights");
        }
    }

    private pushHistory(url: string): void
    {
        this.props.navigate(url, { replace: true });
    }

    public render(): JSX.Element
    {
        return (
            <div>
                <div className="redirectContainer">
                    <div className="title">{this.labels.Platform_RedirectionStatus_Title}</div>
                    <div className="subtitle">{this.labels.Platform_RedirectionStatus_SubTitle} <span id="countdown"></span></div>
                </div>
            </div>
        );
    }
}

export default withRouting(Root);
